import React from 'react'

const Counter = ({count, setCount, order}) => {

  const handleClick = event => {
    event.preventDefault();

    const value = event.target.textContent;

    if (value === '+') {
      setCount(++count)
    } else if (value === '-' && count > 1) {
      setCount(--count)
    }
  };

  return (
    <div className={`basket-item__quantity${order ? '-order' : ''}`}
          onClick={handleClick}>
      <div className="basket-item__quantity-change basket-item-list__quantity-change_minus">-</div>
      {count}
      <div className="basket-item__quantity-change basket-item-list__quantity-change_plus">+</div>
    </div>
  )
};

export default Counter
